import { render, staticRenderFns } from "./shield.vue?vue&type=template&id=6501e1fa&"
import script from "./shield.vue?vue&type=script&lang=js&"
export * from "./shield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports